export const CB_ZOO_PRODUCTS = [
    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Nuoc ngot",
      "NAME": "Nuoc ngot",
      "UOM": "SP",
      "PRODUCT_PRICE": 13636.3636,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Snack 10K",
      "NAME": "Snack 10K",
      "UOM": "SP",
      "PRODUCT_PRICE": 9090.9090,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Banh Ca 20K",
      "NAME": "Banh Ca 20K",
      "UOM": "SP",
      "PRODUCT_PRICE": 18181.8181,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "T/An Nhanh 15K",
      "NAME": "T/An Nhanh 15K",
      "UOM": "SP",
      "PRODUCT_PRICE": 13636.3636,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },


    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Nuoc suoi 10",
      "NAME": "Nuoc suoi 10",
      "UOM": "SP",
      "PRODUCT_PRICE": 9090.9090,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },
    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Nuoc suoi 20",
      "NAME": "Nuoc suoi 20",
      "UOM": "SP",
      "PRODUCT_PRICE": 18181.8181,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },
    
    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Tra da",
      "NAME": "Tra da",
      "UOM": "SP",
      "PRODUCT_PRICE": 1818.1818,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },
    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Nuoc mia 6",
      "NAME": "Nuoc mia 6",
      "UOM": "SP",
      "PRODUCT_PRICE": 5454.5454,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },
    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Nuoc mia 10",
      "NAME": "Nuoc mia 10",
      "UOM": "SP",
      "PRODUCT_PRICE": 9090.9090,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Sua hop 10",
      "NAME": "Sua hop 10",
      "UOM": "SP",
      "PRODUCT_PRICE": 9090.9090,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },
    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Sua hop 12",
      "NAME": "Sua hop 12",
      "UOM": "SP",
      "PRODUCT_PRICE": 10909.0909,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Sua chai/lon 15",
      "NAME": "Sua chai/lon 15",
      "UOM": "SP",
      "PRODUCT_PRICE": 13636.3636,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Sua chai/lon 20",
      "NAME": "Sua chai/lon 20",
      "UOM": "SP",
      "PRODUCT_PRICE": 18181.8181,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Cafe Ly 10",
      "NAME": "Cafe Ly 10",
      "UOM": "SP",
      "PRODUCT_PRICE": 9090.9090,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Cafe Ly 15",
      "NAME": "Cafe Ly 15",
      "UOM": "SP",
      "PRODUCT_PRICE": 13636.3636,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Cafe Ly 20",
      "NAME": "Cafe Ly 20",
      "UOM": "SP",
      "PRODUCT_PRICE": 18181.8181,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Kem Cay/Hop",
      "NAME": "Kem Cay/Hop",
      "UOM": "SP",
      "PRODUCT_PRICE": 13636.3636,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Kem banh 20",
      "NAME": "Kem banh 20",
      "UOM": "SP",
      "PRODUCT_PRICE": 18181.8181,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 1,
      "UOM_NAME": "",
    },

    // AM THUC
    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Com 20",
      "NAME": "Com 20",
      "UOM": "SP",
      "PRODUCT_PRICE": 18181.8181,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Com 25",
      "NAME": "Com 25",
      "UOM": "SP",
      "PRODUCT_PRICE": 22727.2727,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },
    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Com 30",
      "NAME": "Com 30",
      "UOM": "SP",
      "PRODUCT_PRICE": 27272.7373,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },
    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Com 35",
      "NAME": "Com 35",
      "UOM": "SP",
      "PRODUCT_PRICE": 31818.1818,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },
    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Com 40",
      "NAME": "Com 40",
      "UOM": "SP",
      "PRODUCT_PRICE": 36363.64,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Com 45",
      "NAME": "Com 45",
      "UOM": "SP",
      "PRODUCT_PRICE": 40909.0909,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Banh mi 3K",
      "NAME": "Banh mi 3K",
      "UOM": "SP",
      "PRODUCT_PRICE": 2727.2727,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Banh mi 5K",
      "NAME": "Banh mi 5K",
      "UOM": "SP",
      "PRODUCT_PRICE": 4545.4545,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Banh mi 20K",
      "NAME": "Banh mi 20K",
      "UOM": "SP",
      "PRODUCT_PRICE": 18181.8181,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },
    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Banh mi 25K",
      "NAME": "Banh mi 25K",
      "UOM": "SP",
      "PRODUCT_PRICE": 22727.2727,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Ca vien xien 10k",
      "NAME": "Ca vien xien 10k",
      "UOM": "SP",
      "PRODUCT_PRICE": 9090.9090,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Bo vien xien 12k",
      "NAME": "Bo vien xien 12k",
      "UOM": "SP",
      "PRODUCT_PRICE": 10909.0909,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },

    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Xucxich xien12k",
      "NAME": "Xucxich xien12k",
      "UOM": "SP",
      "PRODUCT_PRICE": 10909.0909,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },


    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "My ly 12k",
      "NAME": "My Ly 12k",
      "UOM": "SP",
      "PRODUCT_PRICE": 10909.0909,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },


    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Ga ran 35K",
      "NAME": "Ga ran 35K",
      "UOM": "SP",
      "PRODUCT_PRICE": 31818.1818,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },
    {
      "BLOCK_NAME" : "KHU NHẬP HÀNG KINH DOANH",
      "MARKUP_NAME": "Banh bao 20K",
      "NAME": "Banh bao 20K",
      "UOM": "SP",
      "PRODUCT_PRICE": 18181.8181,
      "VAT_TAX" : 10  ,
      "PRODUCT_CODE": "",
      "PRODUCT_ID": -1,     
      "QUANTITY": 0,
      "UOM_ID": -1,
      "CATEGORY_ID" : 2,
      "UOM_NAME": "",
    },

]


// WEBPACK FOOTER //
// ./src/cbSettings/cbZooFixProducts.ts